var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/mobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.75 28.4375H11.25C5.7375 28.4375 4.0625 26.7625 4.0625 21.25V8.75C4.0625 3.2375 5.7375 1.5625 11.25 1.5625H18.75C24.2625 1.5625 25.9375 3.2375 25.9375 8.75V21.25C25.9375 26.7625 24.2625 28.4375 18.75 28.4375ZM11.25 3.4375C6.775 3.4375 5.9375 4.2875 5.9375 8.75V21.25C5.9375 25.7125 6.775 26.5625 11.25 26.5625H18.75C23.225 26.5625 24.0625 25.7125 24.0625 21.25V8.75C24.0625 4.2875 23.225 3.4375 18.75 3.4375H11.25Z",
    fill: "#CD9803"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M17.5 7.8125H12.5C11.9875 7.8125 11.5625 7.3875 11.5625 6.875C11.5625 6.3625 11.9875 5.9375 12.5 5.9375H17.5C18.0125 5.9375 18.4375 6.3625 18.4375 6.875C18.4375 7.3875 18.0125 7.8125 17.5 7.8125Z",
    fill: "#CD9803"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M15 24.825C13.4125 24.825 12.125 23.5374 12.125 21.9499C12.125 20.3625 13.4125 19.075 15 19.075C16.5875 19.075 17.875 20.3625 17.875 21.9499C17.875 23.5374 16.5875 24.825 15 24.825ZM15 20.9375C14.45 20.9375 14 21.3874 14 21.9374C14 22.4874 14.45 22.9375 15 22.9375C15.55 22.9375 16 22.4874 16 21.9374C16 21.3874 15.55 20.9375 15 20.9375Z",
    fill: "#CD9803"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.06096b0eaa6979775b822a94c6eb8de0.svg";
export { ForwardRef as ReactComponent };